import _ from 'lodash';

const getters = {
  pages: (state) => state.pages,
  includeInFooterRow1: (state) => _.filter(state.pages, { IncludeInFooterRow1: true }),
  includeInFooterRow2: (state) => _.filter(state.pages, { IncludeInFooterRow2: true }),
  includeInFooterRow3: (state) => _.filter(state.pages, { IncludeInFooterRow3: true }),
  includeInSitemap: (state) => _.filter(state.pages, { IncludeInSitemap: true }),
  includeInTopMenu: (state) => _.filter(state.pages, { IncludeInTopMenu: true }),
};

export default getters;
